import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Checkbox } from "@/components/ui/checkbox";
import { Badge } from "@/components/ui/badge";
import { Filter } from "lucide-react";
import { DEFAULT_DOMAINS } from "./constants";

const FilterPanel = ({
  open,
  onOpenChange,
  showCompleted,
  setShowCompleted,
  showOnlyUrgent,
  setShowOnlyUrgent,
  showOnlyTop3,
  setShowOnlyTop3,
  selectedDomains,
  toggleDomainFilter,
  setSelectedDomains,
  resetFilters,
  activeFiltersCount,
  customDomains
}) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetTrigger asChild>
        <Button variant="outline" className="rounded-full gap-2">
          <Filter className="w-4 h-4" />
          Filtri
          {activeFiltersCount > 0 && (
            <Badge className="bg-indigo-600 text-white text-xs ml-1">{activeFiltersCount}</Badge>
          )}
        </Button>
      </SheetTrigger>
      <SheetContent className="w-[320px]">
        <SheetHeader>
          <SheetTitle>Filtri</SheetTitle>
        </SheetHeader>
        <div className="space-y-6 pt-6">
          {/* Stato filtri */}
          <div className="space-y-3">
            <p className="text-sm font-medium text-gray-700">Stato</p>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox checked={showCompleted} onCheckedChange={setShowCompleted} />
              <span className="text-sm">Completati</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox checked={showOnlyUrgent} onCheckedChange={setShowOnlyUrgent} />
              <span className="text-sm">Solo urgenti</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox checked={showOnlyTop3} onCheckedChange={setShowOnlyTop3} />
              <span className="text-sm">Solo Top 3</span>
            </label>
          </div>
          
          {/* Categorie */}
          <div className="space-y-3">
            <p className="text-sm font-medium text-gray-700">Categorie</p>
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => setSelectedDomains([])}
                className={`px-3 py-1.5 rounded-full text-sm transition-all ${
                  selectedDomains.length === 0 
                    ? 'bg-indigo-600 text-white' 
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                Tutte
              </button>
              {Object.entries(DEFAULT_DOMAINS).map(([key, { label, emoji }]) => (
                <button
                  key={key}
                  onClick={() => toggleDomainFilter(key)}
                  className={`px-3 py-1.5 rounded-full text-sm transition-all ${
                    selectedDomains.includes(key) 
                      ? 'bg-indigo-600 text-white' 
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  {emoji} {label}
                </button>
              ))}
              {/* Categorie personalizzate */}
              {customDomains.map(cd => (
                <button
                  key={cd.domain_id}
                  onClick={() => toggleDomainFilter(`custom_${cd.domain_id}`)}
                  className={`px-3 py-1.5 rounded-full text-sm transition-all ${
                    selectedDomains.includes(`custom_${cd.domain_id}`) 
                      ? 'bg-indigo-600 text-white' 
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  📌 {cd.name}
                </button>
              ))}
            </div>
          </div>
          
          {activeFiltersCount > 0 && (
            <Button variant="ghost" onClick={resetFilters} className="w-full">
              Resetta filtri
            </Button>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default FilterPanel;
